import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
    root: {
        maxWidth: '100%',
    },
    media: {
        height: 0,
        paddingTop: '100%',
    },
    link: {
        textDecoration: 'none',
        color: '#000',
    },
}));